module.exports = __webpack_public_path__ + "img/photo-02.d227834c.png";